import { getCurrentDesign } from "@tSurya/theme/design";

function buildShadows() {
    var C = getCurrentDesign().COLORS;
    return {
        small: `0 0 1px 0 ${C.shadow.light}, 0 4px 8px 0 ${C.shadow.base}`,
        main: `0 0 1px 0 ${C.shadow.light}, 0 8px 16px 0 ${C.shadow.base}`,
    };
}

var shadowsProxy = new Proxy({} as ReturnType<typeof buildShadows>, {
    get: function(_target, prop) {
        return (buildShadows() as any)[prop];
    },
    ownKeys: function() {
        return Object.keys(buildShadows());
    },
    getOwnPropertyDescriptor: function(_target, prop) {
        var s = buildShadows() as any;
        if (prop in s) {
            return { configurable: true, enumerable: true, writable: true, value: s[prop] };
        }
        return undefined;
    },
    has: function(_target, prop) {
        return prop in buildShadows();
    }
});

export default shadowsProxy;
